import React, { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { Form, Input, Modal, Spin } from 'antd';
import sendCodeToAddEmail from '../../requests/sendCodeToAddEmail';
import moment from 'moment';
import saveNewEmail from '../../requests/saveNewEmail';
import RestTimeToResendCodeMessage from '../RestTimeToResendCodeMessage/RestTimeToResendCodeMessage';
import DispexButton from '../../../../components/DispexButton/DispexButton';
import validateEmail from '../../../../helpers/validateEmail';

const AddEmailPopup = ({ onExit }) => {
  const [loading, setLoading] = useState(false);
  const [codeSent, setCodeSent] = useState(false);
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [emailValidationError, setEmailValifationError] = useState(false);
  const [timeForRepeatCode, setTimeToRepeatCode] = useState(0);
  const [restOfTimeGreaterThanZero, setRestOfTimeGreaterThanZero] =
    useState(false);
  useEffect(() => {
    const interval = setInterval(() => {
      setRestOfTimeGreaterThanZero(
        moment(timeForRepeatCode).diff(moment(), 's') > 0
      );
    }, 1000);
    return () => clearInterval(interval);
  }, [timeForRepeatCode]);
  useEffect(() => {
    if (email) {
      setEmailValifationError(!validateEmail(email));
    }
  }, [email]);
  const onOk = useCallback(async () => {
    setLoading(true);
    const success = await saveNewEmail(code);
    setLoading(false);
    if (success) {
      onExit();
    }
  }, [code, onExit]);
  const sendCode = useCallback(async () => {
    setLoading(true);
    await sendCodeToAddEmail(email);
    setLoading(false);
    setCodeSent(true);
    setTimeToRepeatCode(moment().add(120, 's'));
  }, [email]);
  const onEmailChange = useCallback((e) => setEmail(e.target.value), []);
  const onCodeChange = useCallback((e) => setCode(e.target.value), []);
  const onCancel = useCallback(() => {
    if (!loading) {
      onExit();
    }
  });
  const okButtonProps = useMemo(
    () => ({
      disabled: loading || !code || !email,
    }),
    [loading, code, email]
  );
  return (
    <Modal
      visible={true}
      title="Добавление почты"
      onCancel={onCancel}
      onOk={onOk}
      okButtonProps={okButtonProps}
    >
      <Spin spinning={loading}>
        <div className="row">
          {codeSent && restOfTimeGreaterThanZero && (
            <RestTimeToResendCodeMessage
              timeForRepeatCode={timeForRepeatCode}
            />
          )}
        </div>
        <div className="row">
          <div className="col">
            <Form.Item
              label="Ваша почта"
              className="formItem"
              help={
                emailValidationError && email
                  ? 'Пожалуйста, укажите действительную почту'
                  : ''
              }
              validateStatus={emailValidationError && email ? 'error' : 'success'}
            >
              <Input onChange={onEmailChange} value={email} />
            </Form.Item>
          </div>
          <div className="col">
            <Form.Item label="Код" className="formItem">
              <Input
                disabled={!codeSent}
                onChange={onCodeChange}
                value={code}
              />
            </Form.Item>
          </div>
        </div>
        <div className="row">
          <DispexButton
            type="primary"
            onClick={sendCode}
            disabled={
              !email || restOfTimeGreaterThanZero || emailValidationError
            }
          >
            Отправить код на почту
          </DispexButton>
        </div>
      </Spin>
    </Modal>
  );
};

export default memo(AddEmailPopup);
